/* Virnous Theme JS */

/* ── Mobile nav ── */
const toggle = document.querySelector('.site-header__menu-toggle');
const mobileNav = document.getElementById('mobile-nav');
if (toggle && mobileNav) {
  toggle.addEventListener('click', () => {
    mobileNav.classList.toggle('is-open');
  });
}

/* ── Cart drawer ── */
const cartOverlay = document.querySelector('.cart-overlay');
const cartDrawer  = document.querySelector('.cart-drawer');
const cartClose   = document.querySelector('.cart-drawer__close');
const cartTriggers = document.querySelectorAll('[data-cart-trigger]');

function openCart() {
  cartDrawer?.classList.add('is-open');
  cartOverlay?.classList.add('is-open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  cartDrawer?.classList.remove('is-open');
  cartOverlay?.classList.remove('is-open');
  document.body.style.overflow = '';
}
cartTriggers.forEach(t => t.addEventListener('click', e => { e.preventDefault(); openCart(); }));
cartClose?.addEventListener('click', closeCart);
cartOverlay?.addEventListener('click', closeCart);

/* ── Add to cart (product page) ── */
const addToCartForm = document.querySelector('[data-product-form]');
if (addToCartForm) {
  addToCartForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = addToCartForm.querySelector('.product-form__add');
    const variantId = addToCartForm.querySelector('[name="id"]')?.value;
    if (!variantId) return;

    btn.textContent = 'Adding...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (res.ok) {
        btn.textContent = 'Added!';
        await refreshCart();
        setTimeout(() => openCart(), 300);
      } else {
        btn.textContent = 'Try again';
      }
    } catch (err) {
      btn.textContent = 'Error';
    }
    setTimeout(() => {
      btn.textContent = 'Add to Cart';
      btn.disabled = false;
    }, 2000);
  });
}

/* ── Refresh cart drawer contents ── */
async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const body = document.querySelector('.cart-drawer__body');
    const subtotalEl = document.querySelector('.cart-drawer__subtotal span:last-child');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty">Your cart is empty.</div>';
    } else {
      body.innerHTML = cart.items.map(item => `
        <div class="cart-item">
          <img class="cart-item__img" src="${item.image}" alt="${item.title}">
          <div class="cart-item__info">
            <div class="cart-item__title">${item.title}</div>
            <div class="cart-item__price">${formatMoney(item.price)}</div>
            <button class="cart-item__remove" data-key="${item.key}">Remove</button>
          </div>
        </div>
      `).join('');

      body.querySelectorAll('.cart-item__remove').forEach(btn => {
        btn.addEventListener('click', async () => {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
          });
          refreshCart();
        });
      });
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  } catch(e) {}
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

refreshCart();
